module.exports = __webpack_public_path__ + "img/tutorial3.6766f3a4.png";